import { render, staticRenderFns } from "./sup-event-bonus.vue?vue&type=template&id=c4ff7f38"
import script from "./sup-event-bonus.vue?vue&type=script&lang=js"
export * from "./sup-event-bonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports